module.exports = __webpack_public_path__ + "static/media/bo.cd93219f.svg";